'use client';
import React, { useEffect } from 'react';
import useGooglePlace from '@/hooks/useGooglePlace';

type Props = {
  lat: string;
  lng: string;
  name: string;
  street: string;
  city: string;
  id: string;
};

export default function RestaurantLocationMap({
  lat,
  lng,
  name,
  street,
  city,
  id,
}: Props) {
  const { initMap } = useGooglePlace();

  useEffect(() => {
    const resRadius = 0;
    // console.log();
    initMap(
      {
        lat: parseFloat(lat),
        lng: parseFloat(lng),
      },
      resRadius,
      {
        name: name,
        address: { street, city },
      },
      id
    );
  }, []);

  //   console.log(lat);

  return (
    <div id={id} className="h-[400px] w-full">
      Loading map
    </div>
  );
}
